module.exports = __webpack_public_path__ + "img/arrow-red-long.e6f078dd.svg";